(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/e-instant-react/assets/javascripts/lobby/info-overlay.js') >= 0) return;  svs.modules.push('/modules/e-instant-react/assets/javascripts/lobby/info-overlay.js');
"use strict";

const {
  GAME_URL,
  LOADING_INFO_IMAGES
} = svs.eInstant.lobby.actions;
const updateSeoTagsAndTitle = ticketInfo => {
  var _routeMatch$title, _routeMatch$metaDescr, _routeMatch$metaKeywo;
  let {
    seoTitle,
    seoDescription,
    seoKeywords,
    name
  } = ticketInfo;
  seoTitle = seoTitle || name;
  seoDescription = seoDescription || name;
  seoKeywords = seoKeywords || name;
  const {
    GAME_INFO
  } = svs.eInstant.constants.ROUTES;
  const routeMatch = svs.core.data.routesMetaData[GAME_INFO];
  seoTitle = ((_routeMatch$title = routeMatch.title) === null || _routeMatch$title === void 0 ? void 0 : _routeMatch$title.replace(/{{seoTitle}}/g, seoTitle)) || seoTitle;
  seoDescription = ((_routeMatch$metaDescr = routeMatch.metaDescription) === null || _routeMatch$metaDescr === void 0 ? void 0 : _routeMatch$metaDescr.replace(/{{productMetaDescription}}/g, seoDescription)) || seoDescription;
  seoKeywords = ((_routeMatch$metaKeywo = routeMatch.metaKeywords) === null || _routeMatch$metaKeywo === void 0 ? void 0 : _routeMatch$metaKeywo.replace(/{{productMetaKeywords}}/g, seoKeywords)) || seoKeywords;
  document.title = seoTitle;
  svs.eInstant.util.setMetaTags(seoTitle, seoDescription, seoKeywords);
};
const InfoOverlay = () => {
  const {
    useEffect,
    useContext,
    useCallback,
    useMemo,
    useState,
    useRef
  } = React;
  const {
    gameConfigs,
    state,
    dispatch
  } = useContext(svs.eInstant.lobby.LobbyContext);
  const {
    useHistory
  } = ReactRouterDOM;
  const history = useHistory();
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const mountedRef = useRef(false);
  const {
    hideFooter,
    createAnimationTimeline
  } = svs.eInstant.util;
  const {
    InfoProvider,
    Info
  } = svs.eInstant.shared.info;
  const onImagesLoaded = useCallback(() => {
    if (!mountedRef.current) {
      return;
    }
    setImagesLoaded(true);
    dispatch({
      type: LOADING_INFO_IMAGES,
      payload: false
    });
  }, [dispatch]);
  const onHideAnimationDone = useCallback(() => {
    if (!mountedRef.current) {
      return;
    }
    dispatch({
      type: GAME_URL,
      payload: {
        gameUrl: null
      }
    });
  }, [dispatch]);
  const {
    showInfo,
    hideInfo,
    kill
  } = useMemo(() => createAnimationTimeline(onImagesLoaded, onHideAnimationDone, state.gameUrl), [onImagesLoaded, onHideAnimationDone, state.gameUrl]);
  const onClose = useCallback(e => {
    e === null || e === void 0 || e.preventDefault();
    history.push(svs.eInstant.constants.ROUTES.LOBBY);
    hideInfo();
  }, [hideInfo]);
  useEffect(() => {
    dispatch({
      type: LOADING_INFO_IMAGES,
      payload: true
    });
    showInfo();
  }, [dispatch, state.gameUrl]);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      kill();
    };
  }, [kill]);
  useEffect(() => {
    var _document$querySelect;
    hideFooter();
    (_document$querySelect = document.querySelector('html')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('disable-body-scroll');
    const ticketInfo = gameConfigs.find(g => g.url === state.gameUrl) || {};
    updateSeoTagsAndTitle(ticketInfo);
    return () => {
      var _document$querySelect2;
      (_document$querySelect2 = document.querySelector('html')) === null || _document$querySelect2 === void 0 || _document$querySelect2.classList.remove('disable-body-scroll');
    };
  }, []);
  return React.createElement(InfoProvider, {
    gameUrl: state.gameUrl
  }, React.createElement(Info, {
    onClose: onClose,
    show: imagesLoaded
  }));
};
setGlobal('svs.eInstant.lobby.InfoOverlay', InfoOverlay);

 })(window);